import button from './button';
import modal from './modal';

export default {
	button,
	modal,
};